import { Transition } from "@tm/morpheus"

export const transitionsToBasket: Array<Transition> = [
    // This transition cannot be deleted as long the micro "vehicle-overview" in CRM bundle is used. The Vehicle description is only relevant for the costestimation voucher.
    {
        transmit: { bundle: "crm", action: "VEHICLE_OVERVIEW_LOADED" },
        receive: { bundle: "basket", action: "VEHICLE_OVERVIEW_LOADED" },
    },
]
